(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7695],{

/***/ 51442:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events",
      function () {
        return __webpack_require__(17100);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 72767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Chevron = ({ width =13 , height =21 , color ="#0B0C2D"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 13 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 19L11.5 10.6667L1.5 1.5",
            stroke: color,
            "stroke-width": "3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chevron);


/***/ }),

/***/ 63098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28154);
/* harmony import */ var _Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Spinner = ({ width =40 , height =40  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (_Spinner_module_scss__WEBPACK_IMPORTED_MODULE_2___default().spinner),
        style: {
            width,
            height
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useDebounce.ts

/**
 * Returns a debounced version of `callback` that delays invoking it until
 * `delay` milliseconds have passed since the last call. The returned function
 * keeps a stable identity across renders, and any pending call is cancelled
 * on unmount.
 *
 * @param callback The function to debounce.
 * @param delay Delay in milliseconds (defaults to 500ms).
 */ const useDebounce = (callback, delay = 500)=>{
    const timer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    // Keep the latest callback without changing the debounced function's identity.
    const callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const debounced = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const fn = (...args)=>{
            if (timer.current) {
                clearTimeout(timer.current);
            }
            timer.current = setTimeout(()=>{
                callbackRef.current(...args);
            }, delay);
        };
        fn.cancel = ()=>{
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
        return fn;
    }, [
        delay
    ]);
    // Cancel any pending invocation on unmount.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>debounced.cancel(), [
        debounced
    ]);
    return debounced;
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 14523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useIsMobile.ts

const useIsMobile = (breakpoint = 768)=>{
    const { 0: isMobile , 1: setIsMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleChange = (e)=>{
            setIsMobile(e.matches);
        };
        // Set initial value
        setIsMobile(mediaQuery.matches);
        // Listen for changes
        mediaQuery.addEventListener("change", handleChange);
        return ()=>{
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, [
        breakpoint
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 17100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ events; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./components/NeedGuidance.tsx
var NeedGuidance = __webpack_require__(84623);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./components/UpcomingEvents/UeTable/UeTable.module.scss
var UeTable_module = __webpack_require__(34381);
var UeTable_module_default = /*#__PURE__*/__webpack_require__.n(UeTable_module);
// EXTERNAL MODULE: ./components/UI/Table/Table.module.scss
var Table_module = __webpack_require__(77832);
var Table_module_default = /*#__PURE__*/__webpack_require__.n(Table_module);
// EXTERNAL MODULE: ./components/UI/Icons/Chevron.tsx
var Chevron = __webpack_require__(72767);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(50549);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(34714);
;// CONCATENATED MODULE: ./components/UI/Table/Table.tsx







const Table = ({ columnHeaders , tableData , pagination =true , rowsPerPage =5 , noDataMessage ="No Entries to show" , totalItems =0 , onPageChange , loading =false , currentPage: controlledPage  })=>{
    const { 0: currentPage , 1: setCurrentPage  } = (0,react.useState)(1);
    const { 0: totalPages , 1: setTotalPages  } = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        setTotalPages(Math.ceil(totalItems / rowsPerPage));
    }, [
        totalItems,
        rowsPerPage
    ]);
    // Sync the highlighted page to the page reported by the parent
    (0,react.useEffect)(()=>{
        if (controlledPage != null) setCurrentPage(controlledPage);
    }, [
        controlledPage
    ]);
    const leftBtnClickHandler = ()=>{
        setCurrentPage((prevState)=>{
            if (prevState === 1) return 1;
            const newPage = prevState - 1;
            onPageChange?.(newPage);
            return newPage;
        });
    };
    const rightBtnClickHandler = ()=>{
        setCurrentPage((prevState)=>{
            if (prevState === totalPages) return prevState;
            const newPage = prevState + 1;
            onPageChange?.(newPage);
            return newPage;
        });
    };
    const pageBtnClickHandler = (page)=>()=>{
            setCurrentPage(page);
            onPageChange?.(page);
        };
    const btnClickHandler = (btnLink)=>()=>{
            window.open(btnLink, "_blank");
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Table_module_default())["table-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: columnHeaders.map((header)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    style: {
                                        whiteSpace: "nowrap"
                                    },
                                    children: header.label
                                }, header.key))
                        })
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: Array.from({
                            length: rowsPerPage
                        }).map((_, rowIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: columnHeaders.map((header)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        style: header.style,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {})
                                    }, header.key))
                            }, rowIndex))
                    }) : tableData && tableData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: tableData.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: columnHeaders.map((header)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        style: header.style,
                                        children: header?.type === "link" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: `${(Table_module_default())["register-button"]} ${!row[header.key]?.link && (0,helpers/* isFrappeOrJotFormClass */.gd)(row[header.key]?.formId)}`,
                                            onClick: row[header.key]?.link ? btnClickHandler(row[header.key]?.link) : undefined,
                                            children: [
                                                row[header.key]?.btnTitle,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                                    color: "#FF7361",
                                                    width: 8,
                                                    height: 13
                                                })
                                            ]
                                        }) : row[header.key]
                                    }, header.key))
                            }, row.id))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                colSpan: columnHeaders.length,
                                className: (Table_module_default())["no-data-msg"],
                                children: noDataMessage
                            })
                        })
                    })
                ]
            }),
            pagination && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Table_module_default())["pagination-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: `${(Table_module_default())["pagination-left-button"]} ${currentPage === 1 ? (Table_module_default())["button-disabled"] : ""}`,
                        onClick: leftBtnClickHandler,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Table_module_default())["pagination-page-buttons-container"],
                        children: Array(totalPages).fill(0).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: `${(Table_module_default())["pagination-page-button"]} ${currentPage === index + 1 ? (Table_module_default())["pagination-page-button-active"] : ""}`,
                                style: currentPage > 3 ? {
                                    transform: `translateX(-${(currentPage - 2) * 64}px)`
                                } : {},
                                onClick: index + 1 != currentPage ? pageBtnClickHandler(index + 1) : ()=>{},
                                children: index + 1
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: `${(Table_module_default())["pagination-right-button"]} ${currentPage === totalPages ? (Table_module_default())["button-disabled"] : ""}`,
                        onClick: rightBtnClickHandler,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Table_Table = (Table);

// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
// EXTERNAL MODULE: ./components/UpcomingEvents/EventList/EventList.module.scss
var EventList_module = __webpack_require__(30187);
var EventList_module_default = /*#__PURE__*/__webpack_require__.n(EventList_module);
;// CONCATENATED MODULE: ./components/UpcomingEvents/EventList/EventList.tsx





const EventList = ({ tableData  })=>{
    const { 0: currentPage , 1: setCurrentPage  } = (0,react.useState)(1);
    const { 0: shortenedTableData , 1: setShortenedTableData  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setShortenedTableData(tableData.slice((currentPage - 1) * 5, currentPage * 5));
    }, [
        tableData,
        currentPage
    ]);
    const pages = Math.ceil(tableData.length / 5);
    const leftBtnClickHandler = ()=>{
        setCurrentPage((prevState)=>{
            if (prevState === 1) return 1;
            return prevState - 1;
        });
    };
    const rightBtnClickHandler = ()=>{
        if (pages === currentPage) return;
        setCurrentPage((prevState)=>prevState + 1);
    };
    const pageBtnClickHandler = (page)=>()=>{
            setCurrentPage(page);
        };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (EventList_module_default())["event-list-container"],
                style: shortenedTableData.length === 0 ? {
                    border: "none"
                } : {},
                children: shortenedTableData?.length > 0 && shortenedTableData?.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (EventList_module_default())["event-list-item"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (EventList_module_default())["event-list-item-title"],
                                children: item?.eventName
                            }),
                            item?.studydestination && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (EventList_module_default())["event-list-item-date"],
                                children: [
                                    "Destination: ",
                                    item?.studydestination
                                ]
                            }),
                            item?.date && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (EventList_module_default())["event-list-item-date"],
                                children: [
                                    "Date: ",
                                    item?.date
                                ]
                            }),
                            item?.time && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (EventList_module_default())["event-list-item-time"],
                                children: [
                                    "Time: ",
                                    item?.time
                                ]
                            }),
                            item?.cities && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (EventList_module_default())["event-list-item-venue"],
                                children: [
                                    "City: ",
                                    item?.cities
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: `${(EventList_module_default())["event-list-item-register-btn"]} ${!item?.register?.link && (0,helpers/* isFrappeOrJotFormClass */.gd)(item?.register?.formId)}`,
                                onClick: item?.register?.link ? ()=>window.open(item.register.link, "_blank") : undefined,
                                children: [
                                    item?.register?.btnTile ?? "Register Now",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                        color: "#FF7361",
                                        width: 8,
                                        height: 13
                                    })
                                ]
                            })
                        ]
                    }, index))
            }),
            shortenedTableData.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (EventList_module_default())["event-list-no-entries"],
                children: "No Entries to show"
            }),
            shortenedTableData.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (EventList_module_default())["pagination-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: `${(EventList_module_default())["pagination-left-button"]} ${currentPage === 1 ? (EventList_module_default())["button-disabled"] : ""}`,
                        onClick: leftBtnClickHandler,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (EventList_module_default())["pagination-page-buttons-container"],
                        children: Array(pages).fill(0).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: `${(EventList_module_default())["pagination-page-button"]} ${currentPage === index + 1 ? (EventList_module_default())["pagination-page-button-active"] : ""}`,
                                style: currentPage > 3 ? {
                                    transform: `translateX(-${(currentPage - 2) * 64}px)`
                                } : {},
                                onClick: pageBtnClickHandler(index + 1),
                                children: index + 1
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: `${(EventList_module_default())["pagination-right-button"]} ${currentPage === pages ? (EventList_module_default())["button-disabled"] : ""}`,
                        onClick: rightBtnClickHandler,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EventList_EventList = (EventList);

// EXTERNAL MODULE: ./components/UpcomingEvents/FilterMenu/FilterMenu.module.scss
var FilterMenu_module = __webpack_require__(92122);
var FilterMenu_module_default = /*#__PURE__*/__webpack_require__.n(FilterMenu_module);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 18 modules
var Modal = __webpack_require__(13540);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/index.js
var react_date_range_dist = __webpack_require__(30286);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var styles = __webpack_require__(71541);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(32049);
;// CONCATENATED MODULE: ./components/UpcomingEvents/FilterMenu/FilterMenu.tsx











const categories = [
    {
        key: "eventType",
        label: "Event Type"
    },
    {
        key: "studyDestination",
        label: "Study Destination"
    },
    {
        key: "countryCity",
        label: "City"
    },
    {
        key: "month",
        label: "Month"
    }, 
];
const createEmptyRange = ()=>[
        {
            startDate: undefined,
            endDate: undefined,
            key: "selection"
        }, 
    ];
const FilterMenu = ({ studyDestinationData =[] , cities =[] , fetchEvents , setEvents , setIsLoading , onFilterChange ,  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(970);
    const { 0: openDropdown , 1: setOpenDropdown  } = (0,react.useState)(null);
    const { 0: showModal , 1: setShowModal  } = (0,react.useState)(false);
    const { 0: activeCategory , 1: setActiveCategory  } = (0,react.useState)("eventType");
    const { 0: selectedEventType , 1: setSelectedEventType  } = (0,react.useState)(null);
    const { 0: selectedDestination , 1: setSelectedDestination  } = (0,react.useState)(null);
    const { 0: selectedCity , 1: setSelectedCity  } = (0,react.useState)(null);
    const { 0: dateRange , 1: setDateRange  } = (0,react.useState)(createEmptyRange);
    const { 0: mobFilters , 1: setMobFilters  } = (0,react.useState)({});
    const { startDate , endDate  } = dateRange[0];
    const noDateSelection = !startDate && !endDate;
    const monthLabel = startDate && endDate ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}` : "Month";
    const toggleDropdown = (key)=>{
        setOpenDropdown((prev)=>prev === key ? null : key);
    };
    const runFetch = async (params)=>{
        setOpenDropdown(null);
        onFilterChange?.(params);
        setIsLoading?.(true);
        const response = await fetchEvents?.(params);
        setEvents(response ?? {});
        setIsLoading?.(false);
    };
    const buildParams = (overrides = {})=>({
            eventType: selectedEventType?.value,
            studydestination: selectedDestination,
            city: selectedCity,
            startDate,
            endDate,
            ...overrides
        });
    const handleEventTypeSelect = (type)=>{
        setSelectedEventType(type);
        runFetch(buildParams({
            eventType: type.value
        }));
    };
    const handleDestinationSelect = (country)=>{
        setSelectedDestination(country);
        runFetch(buildParams({
            studydestination: country
        }));
    };
    const handleCitySelect = (city)=>{
        setSelectedCity(city);
        runFetch(buildParams({
            city
        }));
    };
    const handleMonthApply = ()=>{
        runFetch(buildParams({
            startDate,
            endDate
        }));
    };
    const handleClose = ()=>setShowModal(false);
    const handleShow = ()=>setShowModal(true);
    const clearFilterClickHandler = ()=>{
        runFetch({});
        setSelectedEventType(null);
        setSelectedDestination(null);
        setSelectedCity(null);
        setDateRange(createEmptyRange());
    };
    // Mobile: stage the selection only — no request until "Apply Filters"
    const stageMobFilter = (patch)=>{
        setMobFilters((prev)=>({
                ...prev,
                ...patch
            }));
    };
    const handleApplyFilters = ()=>{
        setShowModal(false);
        runFetch(mobFilters);
    };
    const handleClearMobFilters = ()=>{
        setShowModal(false);
        setMobFilters({});
        setDateRange(createEmptyRange());
        runFetch({});
    };
    // ---------- Mobile layout: search bar + menu button + filter modal ----------
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FilterMenu_module_default()).mobileFilter,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FilterMenu_module_default()).searchBar,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: (FilterMenu_module_default()).searchInput,
                            type: "text",
                            name: "srch-term",
                            id: "srch-term",
                            placeholder: "Search Events"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FilterMenu_module_default()).searchIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/searchco.svg",
                                alt: "search",
                                width: 14,
                                height: 14
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FilterMenu_module_default()).menuButton,
                    onClick: handleShow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                        src: "/new-images/threeline-menu.svg",
                        alt: "filters menu",
                        width: 19,
                        height: 14
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                    show: showModal,
                    onHide: handleClose,
                    className: (FilterMenu_module_default()).filterModal,
                    centered: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FilterMenu_module_default()).categoryTabs,
                                    children: categories.map((cat)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: `${(FilterMenu_module_default()).categoryTab} ${activeCategory === cat.key ? (FilterMenu_module_default()).categoryTabActive : ""}`,
                                            onClick: ()=>setActiveCategory(cat.key),
                                            children: cat.label
                                        }, cat.key))
                                }),
                                activeCategory === "month" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: `${(FilterMenu_module_default())["mobile-month"]} ${noDateSelection ? (FilterMenu_module_default()).emptyRange : ""}`,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_date_range_dist/* DateRange */.C0, {
                                        ranges: dateRange,
                                        shownDate: startDate ?? new Date(),
                                        onChange: (item)=>{
                                            setDateRange([
                                                item.selection
                                            ]);
                                            stageMobFilter({
                                                startDate: item.selection.startDate,
                                                endDate: item.selection.endDate
                                            });
                                        },
                                        moveRangeOnFirstSelection: false,
                                        editableDateInputs: true,
                                        startDatePlaceholder: "Start Date",
                                        endDatePlaceholder: "End Date"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (FilterMenu_module_default()).optionGrid,
                                    children: [
                                        activeCategory === "eventType" && constants/* eventTypes.map */.uS.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(FilterMenu_module_default()).option} ${mobFilters.eventType === type.value ? (FilterMenu_module_default()).optionActive : ""}`,
                                                onClick: ()=>stageMobFilter({
                                                        eventType: type.value
                                                    }),
                                                children: type.label
                                            }, index)),
                                        activeCategory === "studyDestination" && studyDestinationData.map((country)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(FilterMenu_module_default()).option} ${(FilterMenu_module_default())["study-destination-option"]} ${mobFilters.studydestination === country ? (FilterMenu_module_default()).optionActive : ""}`,
                                                onClick: ()=>stageMobFilter({
                                                        studydestination: country
                                                    }),
                                                children: country
                                            }, country)),
                                        activeCategory === "countryCity" && cities.map((city, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: `${(FilterMenu_module_default()).option} ${mobFilters.city === city ? (FilterMenu_module_default()).optionActive : ""}`,
                                                onClick: ()=>stageMobFilter({
                                                        city
                                                    }),
                                                children: city
                                            }, index))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Footer */.Z.Footer, {
                            className: (FilterMenu_module_default()).modalFooter,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (FilterMenu_module_default()).clearBtn,
                                    variant: "secondary",
                                    onClick: handleClearMobFilters,
                                    children: "Clear Filters"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (FilterMenu_module_default()).applyBtn,
                                    variant: "primary",
                                    onClick: handleApplyFilters,
                                    children: "Apply Filters"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    // ---------- Desktop layout: inline dropdown filters ----------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FilterMenu_module_default()).filterMenu,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FilterMenu_module_default()).sortBy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    children: "Sort By:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(FilterMenu_module_default()).filterItem} ${openDropdown === "eventType" ? (FilterMenu_module_default()).open : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FilterMenu_module_default()).filterLabel,
                        onClick: ()=>toggleDropdown("eventType"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: selectedEventType ? selectedEventType.label : "Event Type"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: openDropdown === "eventType" ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                width: 20,
                                height: 8,
                                alt: "dropdown arrow"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterMenu_module_default()).dropdown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: constants/* eventTypes.map */.uS.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: selectedEventType?.value === type.value ? (FilterMenu_module_default()).selected : "",
                                    onClick: ()=>handleEventTypeSelect(type),
                                    children: type.label
                                }, index))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(FilterMenu_module_default()).filterItem} ${openDropdown === "studyDestination" ? (FilterMenu_module_default()).open : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FilterMenu_module_default()).filterLabel,
                        onClick: ()=>toggleDropdown("studyDestination"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: selectedDestination ? selectedDestination : "Study Destinations"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: openDropdown === "studyDestination" ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                width: 20,
                                height: 8,
                                alt: "dropdown arrow"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(FilterMenu_module_default()).dropdown} ${(FilterMenu_module_default())["study-destination-dropdown"]}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: studyDestinationData.map((country)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: selectedDestination === country ? (FilterMenu_module_default()).selected : "",
                                    onClick: ()=>handleDestinationSelect(country),
                                    children: country
                                }, country))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(FilterMenu_module_default()).filterItem} ${openDropdown === "countryCity" ? (FilterMenu_module_default()).open : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FilterMenu_module_default()).filterLabel,
                        onClick: ()=>toggleDropdown("countryCity"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: selectedCity || "City"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: openDropdown === "countryCity" ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                width: 20,
                                height: 8,
                                alt: "dropdown arrow"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterMenu_module_default()).dropdown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: cities.map((city, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: selectedCity === city ? (FilterMenu_module_default()).selected : "",
                                    onClick: ()=>handleCitySelect(city),
                                    children: city
                                }, index))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(FilterMenu_module_default()).filterItem} ${openDropdown === "month" ? (FilterMenu_module_default()).open : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FilterMenu_module_default()).filterLabel,
                        onClick: ()=>toggleDropdown("month"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: monthLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: openDropdown === "month" ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                width: 20,
                                height: 8,
                                alt: "dropdown arrow"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `${(FilterMenu_module_default()).dropdown} ${(FilterMenu_module_default())["month-dropdown"]} ${noDateSelection ? (FilterMenu_module_default()).emptyRange : ""}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_date_range_dist/* DateRange */.C0, {
                                ranges: dateRange,
                                shownDate: startDate ?? new Date(),
                                onChange: (item)=>setDateRange([
                                        item.selection
                                    ]),
                                moveRangeOnFirstSelection: false,
                                editableDateInputs: true,
                                startDatePlaceholder: "Start Date",
                                endDatePlaceholder: "End Date"
                            }, openDropdown === "month" ? "month-open" : "month-closed"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FilterMenu_module_default()).monthApply,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (FilterMenu_module_default()).applyBtn,
                                    variant: "primary",
                                    onClick: handleMonthApply,
                                    children: "Apply"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FilterMenu_module_default()).clearFilter,
                onClick: clearFilterClickHandler,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    children: "Clear Filters"
                })
            })
        ]
    });
};
/* harmony default export */ var FilterMenu_FilterMenu = (FilterMenu);

// EXTERNAL MODULE: ./components/UI/Spinner/Spinner.tsx
var Spinner = __webpack_require__(63098);
// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
;// CONCATENATED MODULE: ./components/UpcomingEvents/UeTable/UeTable.tsx










const ROWS_PER_PAGE = 20;
const COLUMN_HEADERS = [
    {
        label: "Sr. No.",
        key: "srNo",
        style: {
            textAlign: "center"
        }
    },
    {
        label: "Event Name",
        key: "eventName",
        style: {
            width: "200px"
        }
    },
    {
        label: "Study Destination",
        key: "studydestination"
    },
    {
        label: "Event Date",
        key: "date"
    },
    {
        label: "Time",
        key: "time"
    },
    {
        label: "City",
        key: "cities"
    },
    {
        label: "Register Link",
        key: "register",
        type: "link"
    }, 
];
const UeTable = ({ tableData , tableTitle , fetchEvents , studyDestinationData , cities  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(970);
    const { 0: loading , 1: setIsLoading  } = (0,react.useState)(false);
    const { 0: tableDataLoading , 1: setTableDataLoading  } = (0,react.useState)(false);
    const { 0: filteredTableData , 1: setFilteredTableData  } = (0,react.useState)({});
    const { 0: searchInputValue , 1: setSearchInputValue  } = (0,react.useState)("");
    const { 0: activeFilters , 1: setActiveFilters  } = (0,react.useState)({});
    const debouncedFetchEvents = (0,useDebounce/* default */.Z)(async (value)=>{
        setIsLoading(true);
        const response = await fetchEvents({
            searchValue: value
        });
        setFilteredTableData(response ?? {});
        setIsLoading(false);
    });
    (0,react.useEffect)(()=>{
        setFilteredTableData(tableData ?? {});
    }, [
        tableData
    ]);
    const searchInputChangeHandler = (e)=>{
        setSearchInputValue(e.target.value);
        debouncedFetchEvents(e.target.value ?? "");
    };
    const handlePageChange = async (page)=>{
        setTableDataLoading(true);
        const response = await fetchEvents({
            ...activeFilters,
            searchValue: searchInputValue,
            page
        });
        setFilteredTableData(response ?? {});
        setTableDataLoading(false);
    };
    const { page =1 , limit =ROWS_PER_PAGE , total  } = filteredTableData?.meta?.pagination ?? {};
    const tableRows = (0,react.useMemo)(()=>(filteredTableData?.data ?? []).map((entry, index)=>({
                ...entry,
                srNo: (page - 1) * limit + index + 1
            })), [
        filteredTableData,
        page,
        limit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (UeTable_module_default())["ue-table-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (UeTable_module_default())["ue-table-title"],
                children: tableTitle ?? "All our upcoming events of the year"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (UeTable_module_default())["filter-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterMenu_FilterMenu, {
                        fetchEvents: fetchEvents,
                        setEvents: setFilteredTableData,
                        setIsLoading: setIsLoading,
                        onFilterChange: setActiveFilters,
                        studyDestinationData: studyDestinationData,
                        cities: cities
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (UeTable_module_default())["search-bar"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: (UeTable_module_default())["search-input"],
                                type: "text",
                                name: "srch-term",
                                id: "srch-term",
                                placeholder: "Search Events",
                                value: searchInputValue,
                                onChange: searchInputChangeHandler
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (UeTable_module_default())["search-icon"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/searchco.svg",
                                    alt: "search",
                                    width: 14,
                                    height: 14
                                })
                            })
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (UeTable_module_default()).loader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                    width: 48,
                    height: 48
                })
            }) : isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EventList_EventList, {
                tableData: filteredTableData?.data ?? []
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_Table, {
                columnHeaders: COLUMN_HEADERS,
                tableData: tableRows,
                rowsPerPage: ROWS_PER_PAGE,
                onPageChange: handlePageChange,
                currentPage: page,
                totalItems: total ?? filteredTableData?.data?.length,
                loading: tableDataLoading
            })
        ]
    });
};
/* harmony default export */ var UeTable_UeTable = (UeTable);

// EXTERNAL MODULE: ./components/UpcomingEvents/HeroSection/HeroSection.module.scss
var HeroSection_module = __webpack_require__(90216);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
;// CONCATENATED MODULE: ./components/UpcomingEvents/HeroSection/HeroSection.tsx







const HeroSection = ({ heroSectionData  })=>{
    const bannerSettings = {
        dotsClass: (HeroSection_module_default()).paginationDots,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false
    };
    const sliderRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "upcming-evnt-edtech",
        className: (HeroSection_module_default()).heroSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSection_module_default()).breadcrumbSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        lg: 12,
                        md: 12,
                        xs: 12,
                        className: (HeroSection_module_default()).centeredColumn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                        style: {
                                            opacity: 0.5
                                        },
                                        href: "/",
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                        href: "",
                                        children: " Upcoming Events "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...bannerSettings,
                                ref: sliderRef,
                                className: (HeroSection_module_default()).slider,
                                children: heroSectionData?.bannersUrls?.length > 0 && heroSectionData?.banners?.map((banner, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: `${banner.linkUrl}`,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HeroSection_module_default()).bannerSlide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: banner.bannerUrl,
                                                alt: banner.bannerAltTag,
                                                width: 1300,
                                                height: 600,
                                                className: (HeroSection_module_default()).objFit
                                            })
                                        }, banner.id)
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HeroSection_module_default()).navArrows,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HeroSection_module_default()).arrowButton,
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HeroSection_module_default()).arrowButton,
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var HeroSection_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
;// CONCATENATED MODULE: ./components/UpcomingEvents/UpcomingEvents.tsx








const fetchEvents = async ({ searchValue , eventType , studydestination , city , startDate , endDate , limit =20 , page =1  })=>{
    const search = searchValue ? `&eventName_contains=${searchValue}` : "";
    const type = eventType ? `&eventType=${eventType}` : "";
    const stuDest = studydestination ? `&studydestination=${studydestination}` : "";
    const cityField = city ? `&cities_contains=${city}` : "";
    const fromDate = startDate ? `&startDate_gte=${(0,format["default"])(startDate, "yyyy-MM-dd")}` : "";
    const toDate = endDate ? `&startDate_lte=${(0,format["default"])(endDate, "yyyy-MM-dd")}` : "";
    const limitParam = limit ? `&_limit=${limit}` : "";
    return (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/events?_sort=startDate:ASC&showInTable=true&_start=${limit * (page - 1)}${search}${type}${stuDest}${cityField}${fromDate}${toDate}${limitParam}`, "GET", {}, "", false).then((res)=>res ?? {}).catch((err)=>err);
};
const UpcomingEvent = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                heroSectionData: props.pageData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {}),
            props?.eventsData?.data && props?.eventsData?.data?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(UeTable_UeTable, {
                tableData: props?.eventsData,
                tableTitle: props.pageData?.tableTitle,
                studyDestinationData: props?.studyDestinationList,
                cities: props?.citiesData,
                fetchEvents: fetchEvents
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedGuidance/* default */.Z, {
                button2Data: {
                    formId: props.pageData?.meta?.jotforms?.[0]?.jotformid || "main-enquiry-form"
                }
            })
        ]
    });
};
/* harmony default export */ var UpcomingEvents = (UpcomingEvent);

;// CONCATENATED MODULE: ./pages/events.tsx




const Events = (props)=>{
    const { meta  } = props.pageData ?? {};
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#20115b");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpcomingEvents, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var events = (Events);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 28154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__gcxKa","spin":"Spinner_spin__p0RVb"};

/***/ }),

/***/ 77832:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Table_hide-scrollbar__VSLCH","table-container":"Table_table-container__xYOri","loader-container":"Table_loader-container__08pzD","no-data-msg":"Table_no-data-msg__uU7iT","pagination-container":"Table_pagination-container__WT4XH","pagination-page-buttons-container":"Table_pagination-page-buttons-container__m_2HL","pagination-page-button":"Table_pagination-page-button__X0A_S","pagination-page-button-active":"Table_pagination-page-button-active__jxoKA","pagination-left-button":"Table_pagination-left-button__ZBfbA","button-disabled":"Table_button-disabled__Ifhda","register-button":"Table_register-button__qOkUm"};

/***/ }),

/***/ 30187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"EventList_hide-scrollbar__RqXHA","event-list-container":"EventList_event-list-container__6XFeW","event-list-item":"EventList_event-list-item__7J5cV","event-list-item-title":"EventList_event-list-item-title__ZqBID","event-list-item-date":"EventList_event-list-item-date__cA0cD","event-list-item-time":"EventList_event-list-item-time__w5KXA","event-list-item-venue":"EventList_event-list-item-venue__CVYHW","event-list-item-register-btn":"EventList_event-list-item-register-btn__6OLYt","pagination-container":"EventList_pagination-container___T8_w","pagination-page-buttons-container":"EventList_pagination-page-buttons-container__f_AGo","pagination-page-button":"EventList_pagination-page-button__0pr20","pagination-page-button-active":"EventList_pagination-page-button-active__v1zcD","pagination-left-button":"EventList_pagination-left-button__P_6eA","button-disabled":"EventList_button-disabled__FogJ_"};

/***/ }),

/***/ 92122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FilterMenu_hide-scrollbar__dTstj","filterMenu":"FilterMenu_filterMenu__aEJeR","sortBy":"FilterMenu_sortBy__LSY8X","filterItem":"FilterMenu_filterItem__CttTw","open":"FilterMenu_open__K0v_H","filterLabel":"FilterMenu_filterLabel__JpCvp","dropdown":"FilterMenu_dropdown__upNI3","selected":"FilterMenu_selected__EgVoc","study-destination-dropdown":"FilterMenu_study-destination-dropdown__0R2T5","month-dropdown":"FilterMenu_month-dropdown__rZuQn","monthApply":"FilterMenu_monthApply__rxQM9","clearFilter":"FilterMenu_clearFilter__VRvYj","mobileFilter":"FilterMenu_mobileFilter__gej5v","searchBar":"FilterMenu_searchBar__u1crw","searchInput":"FilterMenu_searchInput__mM19p","searchIcon":"FilterMenu_searchIcon__DM1Wi","menuButton":"FilterMenu_menuButton__LPArU","filterModal":"FilterMenu_filterModal__Z5Nsn","categoryTabs":"FilterMenu_categoryTabs__jT5Wv","categoryTab":"FilterMenu_categoryTab__lHc2p","categoryTabActive":"FilterMenu_categoryTabActive__8KL1m","optionGrid":"FilterMenu_optionGrid__tqI44","option":"FilterMenu_option__C6tej","optionActive":"FilterMenu_optionActive__7Ylln","study-destination-option":"FilterMenu_study-destination-option__wQkEf","mobile-month":"FilterMenu_mobile-month__ZHJtp","emptyRange":"FilterMenu_emptyRange__qShbJ","modalFooter":"FilterMenu_modalFooter__3m6Xm","clearBtn":"FilterMenu_clearBtn__e0pib","applyBtn":"FilterMenu_applyBtn__08Vv4"};

/***/ }),

/***/ 90216:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HeroSection_hide-scrollbar__JSaEj","heroSection":"HeroSection_heroSection__tEfQA","breadcrumbSection":"HeroSection_breadcrumbSection__ouD4M","enquireButton":"HeroSection_enquireButton__kUcPF","headingGroup":"HeroSection_headingGroup__LMsMO","buttonGroup":"HeroSection_buttonGroup__AReW2","kcButton":"HeroSection_kcButton__7by9a","centeredColumn":"HeroSection_centeredColumn__eBf4b","expoBox":"HeroSection_expoBox__oFAfu","expoButton":"HeroSection_expoButton__cxtyd","breadcrumb-item":"HeroSection_breadcrumb-item__mcToD","active":"HeroSection_active__lTO8o","hiddenImage":"HeroSection_hiddenImage__I_NTh","bannerSlide":"HeroSection_bannerSlide__qQqLx","paginationDots":"HeroSection_paginationDots__1sya1","navArrows":"HeroSection_navArrows__DXpX0","arrowButton":"HeroSection_arrowButton__bAGps"};

/***/ }),

/***/ 34381:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"UeTable_hide-scrollbar__FQJoz","ue-table-container":"UeTable_ue-table-container__hpqbs","ue-table-title":"UeTable_ue-table-title__koSEL","filter-container":"UeTable_filter-container__ioSVw","search-bar":"UeTable_search-bar__mUWAP","search-input":"UeTable_search-input__QpXRM","search-icon":"UeTable_search-icon__Br_no","loader":"UeTable_loader__78ILV"};

/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,3656,8769,2350,9774,2888,179], function() { return __webpack_exec__(51442); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);